import React, { Component } from 'react';
import { Title } from '../Components';
import LineItem from './LineItem';
import { formatPriceDollars } from '../../../Helpers';
// import Fade from 'react-reveal/Fade';

class StepReviewOrder extends Component {
	constructor() {
		super();
	}


	render() {
		const { selectedSize, typeOptions, totalNoTax, tax, total } = this.props;
		return (
			<div className="BoxBuilder_ReviewOrder">
				{/* <Fade big delay={400}> */}
					<Title title="Review Order" />
				{/* </Fade> */}
				{/* <Fade big delay={500}> */}
					<div className="BoxBuilder_ReviewOrder--OrderSumary">
						<div className="BoxBuilder_ReviewOrder--Notice">You will receive this order once a month. Skip or cancel anytime.</div>
						<ul>
							<li>Item</li>
							<li>Size</li>
							<li>Qty</li>
							<li>Total</li>
						</ul>
						{typeOptions
							.map(option => <LineItem
								{...option}
								size={selectedSize.size}
								key={`line-item-${option.product_id}`}
								setCurrency={this.props.setCurrency}
							/>)
						}
						<ul>
							<li><strong>Subtotal</strong><span>{formatPriceDollars(totalNoTax)}</span></li>
							<li><strong>HST (13%)</strong><span>{formatPriceDollars(tax)}</span></li>
							<li><strong>Total</strong><span>{formatPriceDollars(total)}</span></li>
						</ul>
					</div>
				{/* </Fade> */}
			</div>
		)
	}
}

export default StepReviewOrder;